import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import './ScrollStack.scss';

interface Card {
  video: string;
  title: string;
  text: string;
}

interface ScrollStackProps {
  cards: Card[];
}

export default function ScrollStack({ cards }: ScrollStackProps) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });

  const yTransforms = [
    useTransform(scrollYProgress, [0.00, 0.40], ["0%", "0%"]),
    useTransform(scrollYProgress, [0.40, 0.66], ["150%", "0%"]),
    useTransform(scrollYProgress, [0.66, 0.95], ["150%", "0%"])
  ];

  return (
    <div
      ref={ref}
      className="scroll-stack-container"
    >
      <div
        className="scroll-stack"
      >
        {cards.map((card, index) => (
          <motion.div
            key={index}
            className="scroll-stack-card"
            style={{ 
              y: yTransforms[index], 
              x: "-50%",
              opacity: 1 
            }}
          >
            <video
              src={card.video}
              muted
              autoPlay
              playsInline
              loop
              className="video"
              aria-label={`Video demonstration: ${card.title}`}
            />
            <div style={{ flex: 1 }}>
              <h3>{card.title}</h3>
              <br />
              <p>{card.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
